import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { useMask } from "@react-input/mask";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { PersonnelService } from "../../../services/PersonnelService";
import { AddPersonnelResponse } from "../../../models/response/personnel/AddPersonnelResponse";
import { GetPersonnelByIdResponse } from "../../../models/response/personnel/GetPersonnelByIdResponse";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomDatePicker from "../../../components/CustomDatePicker";
import CustomTextInput from "../../../components/CustomTextInput";
import TedarikciFirmaSecimi from "../../../components/TedarikciFirmaSecimi";
import { RootState } from "../../../redux/store";
import { personelUcretYetkisi } from "../../../services/PersonelUcretService";
import PersonelUcretleri from "./Components/PersonelUcretleri";

const PersonnelAdd = () => {
    const navigate = useNavigate();
    const pageName = "İnsan Kaynakları > Tanımlamalar > Personel Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth);
    // Ücret bölümü yalnız kayıtlı personelde ve "Personel Ücretleri" yetkisi olana görünür.
    const ucretYetkisi = personelUcretYetkisi(auth.user.user?.data.authorizedMenus);

    const [personnelId, setPersonnelId] = useState<string | undefined>(undefined);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const phoneRef = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const [nameSurname, setNameSurname] = useState<string | undefined>(undefined);
    const [tckn, setTckn] = useState<string | undefined>(undefined);
    const [phone, setPhone] = useState<string | undefined>(undefined);
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [iban, setIban] = useState<string | undefined>(undefined);
    const [selectedBank, setSelectedBank] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDepartment, setSelectedDepartment] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDuty, setSelectedDuty] = useState<CustomSingleSelectModel | undefined>(undefined);
    // Personelin calistigi firma; siparis mesai tablosunda pasif alan olarak gorunur.
    const [selectedSupplierCompany, setSelectedSupplierCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState<boolean>(true);
    const [ucretHesaplanmaz, setUcretHesaplanmaz] = useState<boolean>(false);
    const [iseGiris, setIseGiris] = useState<string | undefined>(undefined);
    const [dogum, setDogum] = useState<string | undefined>(undefined);
    const [devreden, setDevreden] = useState<string | undefined>(undefined);
    const [onaylayici, setOnaylayici] = useState<CustomSingleSelectModel | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetPersonnelByIdResponse = await PersonnelService.getPersonnelById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setPersonnelId(response.data.personnelId);
                setNameSurname(response.data.nameSurname);
                setTckn(response.data.tckn);
                setPhone(response.data.phone);
                setEmail(response.data.email);
                setIban(response.data.iban);
                setIsCustomActive(response.data.isCustomActive);
                setUcretHesaplanmaz(!!response.data.ekMesaiUcretiHesaplanmaz);
                setIseGiris(response.data.iseGirisTarihi?.substring(0, 10));
                setDogum(response.data.dogumTarihi?.substring(0, 10));
                setDevreden(response.data.devredenIzinGun == null ? undefined : String(response.data.devredenIzinGun));
                setOnaylayici(undefined);
                if (response.data.izinOnaylayiciPersonnelId) {
                    const liste = await PersonnelService.getPersonnelList(undefined, true);
                    const o = (liste.data ?? []).find((x: any) => x.personnelId == response.data.izinOnaylayiciPersonnelId);
                    setOnaylayici({ label: o?.nameSurname ?? '(pasif personel)', value: response.data.izinOnaylayiciPersonnelId });
                }

                if (response.data.bankId)
                    setSelectedBank({ label: response.data.bankName, value: response.data.bankId });

                if (response.data.currencyTypeId)
                    setSelectedCurrencyType({ label: response.data.currencyTypeName, value: response.data.currencyTypeId });

                if (response.data.departmentId)
                    setSelectedDepartment({ label: response.data.departmentName, value: response.data.departmentId });

                if (response.data.dutyId)
                    setSelectedDuty({ label: response.data.dutyName, value: response.data.dutyId });

                if (response.data.supplierCompanyId && response.data.supplierCompanyName)
                    setSelectedSupplierCompany({ label: response.data.supplierCompanyName, value: response.data.supplierCompanyId });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const savePersonnel = async () => {
        try {
            if (Helpers.isEmpty(nameSurname))
                toast.error('Ad Soyad alanını doldurunuz!')
            else if (!selectedDuty)
                toast.error('Görevi alanını doldurunuz!')
            else if ((!Helpers.isEmpty(phone) && phone && phone.length < 15))
                toast.error('Lütfen geçerli bir telefon numarası giriniz!')
            else if ((!Helpers.isEmpty(email) && email && !Helpers.validateEmail(email)))
                toast.error('Lütfen geçerli bir email adresi giriniz!')
            else if (!Helpers.isEmpty(tckn) && !Helpers.validateTckn(tckn))
                toast.error('Lütfen geçerli bir TC Kimlik No giriniz!')
            else if (devreden && devreden.trim() != '' && isNaN(Number(devreden.replace(',', '.'))))
                toast.error('Devreden izin günü sayı olmalıdır!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddPersonnelResponse = await PersonnelService.addPersonnel({
                    personnelId: personnelId,
                    bankId: selectedBank?.value,
                    currencyTypeId: selectedCurrencyType?.value,
                    departmentId: selectedDepartment?.value,
                    dutyId: selectedDuty?.value,
                    supplierCompanyId: selectedSupplierCompany?.value,
                    email: email,
                    iban: iban,
                    nameSurname: nameSurname,
                    phone: phone,
                    tckn: tckn,
                    isCustomActive: isCustomActive,
                    ekMesaiUcretiHesaplanmaz: ucretHesaplanmaz,
                    iseGirisTarihi: iseGiris || null,
                    dogumTarihi: dogum || null,
                    devredenIzinGun: devreden && devreden.trim() != '' ? Number(devreden.replace(',', '.')) : null,
                    izinOnaylayiciPersonnelId: onaylayici?.value ?? null
                });

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const onIbanChange = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var ibanVal = iban ? iban.replaceAll(" ", "").replace(/[^a-z0-9]/gi, '') : '';

            if (ibanVal.length <= 9) {
                setSelectedBank(undefined);
                setSelectedCurrencyType(undefined);
                return;
            }

            if (ibanVal.length == 26 && !selectedBank) {
                var bankCode = parseInt(ibanVal.substring(4, 9)).toString();

                var response: GetConstantListResponse = await ConstantService.getConstantList('BANK', undefined, bankCode);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                if (response.data.length > 0) {
                    setSelectedBank({ value: response.data[0].constantId, label: response.data[0].value });
                }
                else {
                    setSelectedBank(undefined);
                    setSelectedCurrencyType(undefined);
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ad Soyad</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={nameSurname} onChange={(e) => setNameSurname(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">TC Kimlik No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={tckn} onChange={(e) => setTckn(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Telefon</label>
                                        <input ref={phoneRef} style={{ border: '1px solid #F1F1F4' }} value={phone} onChange={(e) => setPhone(e.target.value)} className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">E-Posta</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">IBAN No</label>
                                        <input onKeyUp={onIbanChange} style={{ border: '1px solid #F1F1F4' }} value={iban} onChange={(e) => setIban(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Banka Adı</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedBank}
                                            onChange={setSelectedBank}
                                            onMenuOpen={() => ConstantService.getConstantList('BANK')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Döviz Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCurrencyType}
                                            onChange={setSelectedCurrencyType}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Departman</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDepartment}
                                            onChange={setSelectedDepartment}
                                            insertable={{
                                                onSubmit: { code: 'COMPANY_DEPARTMENT' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('COMPANY_DEPARTMENT')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Görevi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDuty}
                                            onChange={setSelectedDuty}
                                            onMenuOpen={() => ConstantService.getConstantList('PERSONNEL_DUTY')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <TedarikciFirmaSecimi
                                            selectedValue={selectedSupplierCompany}
                                            onChange={setSelectedSupplierCompany}
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>

                                    <div className="col-md-8">
                                        <label className="form-label">Ek mesai ücreti hesaplanmaz (yalnız saat takibi)</label>

                                        <CustomSwitch isActive={ucretHesaplanmaz} setIsActive={setUcretHesaplanmaz} />
                                        <div className="text-muted fs-8 mt-1">Giriş, çıkış ve ek süre puantajda görünür; ek mesai ücreti hesaplanmaz. Müşteri faturalaması değişmez.</div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-3">
                                        <CustomDatePicker labelText="İşe giriş tarihi" value={iseGiris} setValue={setIseGiris} />
                                    </div>
                                    <div className="col-md-3">
                                        <CustomDatePicker labelText="Doğum tarihi" value={dogum} setValue={setDogum} />
                                    </div>
                                    <div className="col-md-2">
                                        <CustomTextInput labelText="Devreden izin (gün)" value={devreden} setValue={setDevreden} />
                                    </div>
                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            menuPortal
                                            labelText="İzin onaylayıcısı"
                                            selectedValue={onaylayici}
                                            onChange={setOnaylayici}
                                            onMenuOpen={async () => {
                                                const r = await PersonnelService.getPersonnelList(undefined, true);
                                                return { isSuccess: r.isSuccess, data: (r.data ?? []).filter((x: any) => x.personnelId != personnelId).map((x: any) => ({ label: x.nameSurname, value: x.personnelId })) };
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </div>
                                </div>
                                <div className="text-muted fs-8 mt-1">
                                    Yıllık izin hakkı işe giriş tarihinden hesaplanır (İş Kanunu md. 53: 1–5 yıl 14, 5–15 yıl 20, 15 yıl ve üstü 26 gün; 18 yaş altı ve 50 yaş üstü en az 20 gün).
                                    {' '}Devreden: sisteme geçmeden önce kalan izin. İzin onaylayıcısı boşsa görevinde "İzin Onay" yetkisi olanlar onaylar.
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    {
                        personnelId && ucretYetkisi && (
                            <PersonelUcretleri personnelId={personnelId} />
                        )
                    }

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={savePersonnel}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default PersonnelAdd;